// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Tg8y","field":"styles_field___RTHK","fieldCol":"styles_fieldCol__2-aee","diffCol":"styles_diffCol__3HLH3","diff":"styles_diff__12oae"};